<!-- just a wrapper -->
<app-invitations-list></app-invitations-list>